import React, { useMemo } from 'react';
import CustomButton from '../../features/customButton/ui/main/CustomButton';
import Icon from '../../baseComponents/gui/icon/Icon';
import Reward from '../../baseComponents/gui/reward/Reward';
import classNames from 'classnames';
import { safeHTML } from '../../../utils/safeHTML';
import { nyTaskContent } from '../../../constants/copyright';
import { getMoscowTime, getReward } from '../../../utils/helpers';
import { getNecessaryTimeFormat } from '../../../utils/helpers/helpers';
import { useTranslation } from '../../../translations';
import { useLanguageControls } from '../../../hooks/useLanguageControls';

const { quizDescriptions, button } = nyTaskContent;

const NyTaskItem = React.forwardRef(function TaskItem({ el, index, onClick, state, isWin, openQuizModal }, ref) {
  const { title, available_at, correctAnswersCount, correct_answers_requirement, questions, prize } = el;
  const { t } = useTranslation();
  const { value, field } = getReward(prize, t);
  const { isArabic } = useLanguageControls();

  const formattedDescription = useMemo(() => {
    const descriptionLogic = {
      isCompleted: quizDescriptions?.isCompleted,
      isAvailable: quizDescriptions?.isAvailable,
      isClosed:
        getMoscowTime() >= available_at * 1000
          ? quizDescriptions.isAccessibly
          : `${t('other.taskOpen')} ${getNecessaryTimeFormat(available_at, isArabic)}`,
    };

    return descriptionLogic[state] ?? `${t('other.taskOpen')} ${getNecessaryTimeFormat(available_at, isArabic)}`;
  }, [available_at, state, isArabic]);

  const counterLabel = isArabic
    ? `${questions?.length ?? 0}/${correctAnswersCount}`
    : `${correctAnswersCount}/${questions?.length ?? 0}`;

  return (
    <li
      className={classNames('ny-task__item', { 'ny-task__item_completed': state === 'isCompleted' && isWin })}
      key={`ny-task-${index}`}
      style={{ animationDelay: `${0.2 + index * 0.05}s` }}
      onClick={onClick}
    >
      <div className={'ny-task__item-arrow'}>
        <Icon
          name={`tasks/arr`}
          className={classNames('ny-task__item-arrow-img', {
            'ny-task__item-arrow-img_completed': state === 'isCompleted',
          })}
        />
      </div>
      <div className={'ny-task__item-content'}>
        <h3 className={'ny-task__item-title'}>{safeHTML(t(title))}</h3>
        <p className={'ny-task__item-text'}>{safeHTML(t(formattedDescription))}</p>
        {state === 'isAvailable' && <CustomButton {...button} onClick={() => openQuizModal(el)} />}
        {
          {
            isCompleted: (
              <div
                className={classNames('ny-task__item-counter', {
                  'ny-task__item-counter_black': state === 'isCompleted' && !isWin,
                })}
              >
                {counterLabel} {t('other.correct')}
              </div>
            ),
          }[state]
        }
      </div>
      {['number', 'string'].some((type) => typeof value === type) && (
        <div className={'ny-task__item-cost'}>
          <Reward
            value={{ gacha_event_cash: value, promocode: 1 }[field]}
            type={{ gacha_event_cash: 'charm', promocode: 'promo' }[field]}
            mod={'season-task'}
          />
        </div>
      )}
    </li>
  );
});

export default NyTaskItem;
